<button mat-button (click)="navigate()">
    <div class="flexBeetwenCenter">
        <mat-icon class="blackIcon">
            chevron_left
        </mat-icon>
        {{'navigation.students' | translate}}
    </div>
</button>
